var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6469 10.4803C27.5044 10.9679 28.0311 11.8805 28.025 12.8667V21.7897C28.025 22.7808 27.4823 23.6946 26.6064 24.1761L18.3375 29.4069C17.9276 29.632 17.4675 29.75 16.9998 29.75C16.5321 29.75 16.072 29.632 15.6621 29.4069L7.39318 24.1761C6.96463 23.9419 6.60687 23.5968 6.35732 23.177C6.10777 22.7572 5.97559 22.2781 5.97461 21.7897V12.8655C5.97461 11.8744 6.51729 10.9618 7.39318 10.4803L15.6621 5.60475C16.0841 5.37204 16.5583 5.25 17.0402 5.25C17.5222 5.25 17.9963 5.37204 18.4184 5.60475L26.6873 10.4803H26.6469Z",
    fill: "white",
    stroke: "#FAFAFA",
    strokeOpacity: 0.1,
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12.6875H17.0117",
    stroke: "#22262C",
    strokeWidth: 2.08254,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7744 15.9253H16.9994L16.9998 21.6128H18.2248",
    stroke: "#22262C",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.3477487ff605058843c7e913aad0ca45.svg";
export { ForwardRef as ReactComponent };